import React from 'react'
import { useCurrency } from '../../contexts/CurrencyContext'

const PriceDisplay = ({
  amountCad,
  currency: currencyOverride,
  className = '',
  fallback = 'N/A',
  minimumFractionDigits = 2,
  maximumFractionDigits = 2,
  suffix = '',
}) => {
  const {
    currency: selectedCurrency,
    convertCadAmount,
    formatCurrencyAmount,
  } = useCurrency()

  const targetCurrency = currencyOverride || selectedCurrency
  const converted = convertCadAmount(amountCad, targetCurrency)

  if (converted === null) {
    return <span className={className}>{fallback}</span>
  }

  const label = formatCurrencyAmount(converted, targetCurrency, {
    fallback,
    minimumFractionDigits,
    maximumFractionDigits,
  })

  return <span className={className}>{`${label}${suffix}`}</span>
}

export default PriceDisplay
